// views
import { About, Contact, Hero, Projects } from "./views";

// components
import { Menu } from "./components";

function App() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Contact />
      <Menu /> 
    </>
  );
}

export default App;
